import {
  GET_CAPEX_RELATED_BUDGET_INIT,
  GET_CAPEX_RELATED_BUDGET_SUCCESS,
  GET_CAPEX_RELATED_BUDGET_FAILED,
  GET_CAPEX_RELATED_FORECAST_INIT,
  GET_CAPEX_RELATED_FORECAST_SUCCESS,
  GET_CAPEX_RELATED_FORECAST_FAILED,
  GET_DIRECT_EMPLOYEE_BUDGET_INIT,
  GET_DIRECT_EMPLOYEE_BUDGET_SUCCESS,
  GET_DIRECT_EMPLOYEE_BUDGET_FAILED,
  GET_DIRECT_EMPLOYEE_FORECAST_INIT,
  GET_DIRECT_EMPLOYEE_FORECAST_SUCCESS,
  GET_DIRECT_EMPLOYEE_FORECAST_FAILED,
  GET_OTHER_DIRECT_INHOUSE_COST_BUDGET_INIT,
  GET_OTHER_DIRECT_INHOUSE_COST_BUDGET_SUCCESS,
  GET_OTHER_DIRECT_INHOUSE_COST_BUDGET_FAILED,
  GET_OTHER_DIRECT_INHOUSE_COST_FORECAST_INIT,
  GET_OTHER_DIRECT_INHOUSE_COST_FORECAST_SUCCESS,
  GET_OTHER_DIRECT_INHOUSE_COST_FORECAST_FAILED,
  GET_VENDOR_EMPLOYEE_BUDGET_INIT,
  GET_VENDOR_EMPLOYEE_BUDGET_SUCCESS,
  GET_VENDOR_EMPLOYEE_BUDGET_FAILED,
  GET_VENDOR_EMPLOYEE_FORECAST_INIT,
  GET_VENDOR_EMPLOYEE_FORECAST_SUCCESS,
  GET_VENDOR_EMPLOYEE_FORECAST_FAILED,
  GET_VENDOR_RELATED_COST_BUDGET_INIT,
  GET_VENDOR_RELATED_COST_BUDGET_SUCCESS,
  GET_VENDOR_RELATED_COST_BUDGET_FAILED,
  GET_VENDOR_RELATED_COST_FORECAST_INIT,
  GET_VENDOR_RELATED_COST_FORECAST_SUCCESS,
  GET_VENDOR_RELATED_COST_FORECAST_FAILED,
  UPDATE_CAPEX_RELATED_BUDGET_INIT,
  UPDATE_CAPEX_RELATED_BUDGET_SUCCESS,
  UPDATE_CAPEX_RELATED_BUDGET_FAILED,
  UPDATE_CAPEX_RELATED_FORECAST_INIT,
  UPDATE_CAPEX_RELATED_FORECAST_SUCCESS,
  UPDATE_CAPEX_RELATED_FORECAST_FAILED,
  UPDATE_DIRECT_EMPLOYEE_BUDGET_INIT,
  UPDATE_DIRECT_EMPLOYEE_BUDGET_SUCCESS,
  UPDATE_DIRECT_EMPLOYEE_BUDGET_FAILED,
  UPDATE_DIRECT_EMPLOYEE_FORECAST_INIT,
  UPDATE_DIRECT_EMPLOYEE_FORECAST_SUCCESS,
  UPDATE_DIRECT_EMPLOYEE_FORECAST_FAILED,
  UPDATE_OTHER_DIRECT_INHOUSE_COST_BUDGET_INIT,
  UPDATE_OTHER_DIRECT_INHOUSE_COST_BUDGET_SUCCESS,
  UPDATE_OTHER_DIRECT_INHOUSE_COST_BUDGET_FAILED,
  UPDATE_OTHER_DIRECT_INHOUSE_COST_FORECAST_INIT,
  UPDATE_OTHER_DIRECT_INHOUSE_COST_FORECAST_SUCCESS,
  UPDATE_OTHER_DIRECT_INHOUSE_COST_FORECAST_FAILED,
  UPDATE_VENDOR_EMPLOYEE_BUDGET_INIT,
  UPDATE_VENDOR_EMPLOYEE_BUDGET_SUCCESS,
  UPDATE_VENDOR_EMPLOYEE_BUDGET_FAILED,
  UPDATE_VENDOR_EMPLOYEE_FORECAST_INIT,
  UPDATE_VENDOR_EMPLOYEE_FORECAST_SUCCESS,
  UPDATE_VENDOR_EMPLOYEE_FORECAST_FAILED,
  UPDATE_VENDOR_RELATED_COST_BUDGET_INIT,
  UPDATE_VENDOR_RELATED_COST_BUDGET_SUCCESS,
  UPDATE_VENDOR_RELATED_COST_BUDGET_FAILED,
  UPDATE_VENDOR_RELATED_COST_FORECAST_INIT,
  UPDATE_VENDOR_RELATED_COST_FORECAST_SUCCESS,
  UPDATE_VENDOR_RELATED_COST_FORECAST_FAILED,
  GET_FINANCIAL_SUMMARY_BUDGET_INIT,
  GET_FINANCIAL_SUMMARY_BUDGET_SUCCESS,
  GET_FINANCIAL_SUMMARY_BUDGET_FAILED,
  GET_FINANCIAL_SUMMARY_FORECAST_INIT,
  GET_FINANCIAL_SUMMARY_FORECAST_SUCCESS,
  GET_FINANCIAL_SUMMARY_FORECAST_FAILED,
  GET_TOP_PROJECT_VARIANCE_LIST_INIT,
  GET_TOP_PROJECT_VARIANCE_LIST_SUCCESS,
  GET_TOP_PROJECT_VARIANCE_LIST_FAILED,
  GET_BUDGET_VS_FORECAST_INIT,
  GET_BUDGET_VS_FORECAST_SUCCESS,
  GET_BUDGET_VS_FORECAST_FAILED,
  GET_PROJECT_VARIANCES_COST_WATERFALL_INIT,
  GET_PROJECT_VARIANCES_COST_WATERFALL_SUCCESS,
  GET_PROJECT_VARIANCES_COST_WATERFALL_FAILED,
  GET_UPCOMING_DEADLINES_INIT,
  GET_UPCOMING_DEADLINES_SUCCESS,
  GET_UPCOMING_DEADLINES_FAILED,
  GET_CONTRACT_SUMMARY_INIT,
  GET_CONTRACT_SUMMARY_SUCCESS,
  GET_CONTRACT_SUMMARY_FAILED,
  GET_CONTRACT_SUMMARY_COST_PLUS_INIT,
  GET_CONTRACT_SUMMARY_COST_PLUS_SUCCESS,
  GET_CONTRACT_SUMMARY_COST_PLUS_FAILED,
  GET_CONTRACT_SUMMARY_EAC_INIT,
  GET_CONTRACT_SUMMARY_EAC_SUCCESS,
  GET_CONTRACT_SUMMARY_EAC_FAILED,
  GET_DIRECT_LABOR_DETAILS_INIT,
  GET_DIRECT_LABOR_DETAILS_SUCCESS,
  GET_DIRECT_LABOR_DETAILS_FAILED,
  GET_OTHER_DIRECT_COSTS_INIT,
  GET_OTHER_DIRECT_COSTS_SUCCESS,
  GET_OTHER_DIRECT_COSTS_FAILED,
  GET_REVENUE_INIT,
  GET_REVENUE_SUCCESS,
  GET_REVENUE_FAILED,
  GET_MARGIN_INIT,
  GET_MARGIN_SUCCESS,
  GET_MARGIN_FAILED,
  UPDATE_DIRECT_LABOR_DETAILS_INIT,
  UPDATE_DIRECT_LABOR_DETAILS_SUCCESS,
  UPDATE_DIRECT_LABOR_DETAILS_FAILED,
  UPDATE_OTHER_DIRECT_COSTS_INIT,
  UPDATE_OTHER_DIRECT_COSTS_SUCCESS,
  UPDATE_OTHER_DIRECT_COSTS_FAILED,
  UPDATE_REVENUE_INIT,
  UPDATE_REVENUE_SUCCESS,
  UPDATE_REVENUE_FAILED,
  UPDATE_MARGIN_INIT,
  UPDATE_MARGIN_SUCCESS,
  UPDATE_MARGIN_FAILED,
  GET_DETAILED_VIEW_RATES_INIT,
  GET_DETAILED_VIEW_RATES_SUCCESS,
  GET_DETAILED_VIEW_RATES_FAILED,
  GET_CONTRACT_YEARS_INIT,
  GET_CONTRACT_YEARS_SUCCESS,
  GET_CONTRACT_YEARS_FAILED,
  UPDATE_DETAILED_VIEW_RATES_INIT,
  UPDATE_DETAILED_VIEW_RATES_SUCCESS,
  UPDATE_DETAILED_VIEW_RATES_FAILED,
  GET_CONTRACTS_INIT,
  GET_CONTRACTS_SUCCESS,
  GET_CONTRACTS_FAILED,
  DOWNLOAD_DETAILED_VIEW_INIT,
  DOWNLOAD_DETAILED_VIEW_SUCCESS,
  DOWNLOAD_DETAILED_VIEW_FAILED,
  DOWNLOAD_PSR_INIT,
  DOWNLOAD_PSR_SUCCESS,
  DOWNLOAD_PSR_FAILED,
  GET_FINANCIAL_YEAR_SETTINGS_INIT,
  GET_FINANCIAL_YEAR_SETTINGS_SUCCESS,
  GET_FINANCIAL_YEAR_SETTINGS_FAILED,
  GET_FINANCIAL_YEARS_INIT,
  GET_FINANCIAL_YEARS_SUCCESS,
  GET_FINANCIAL_YEARS_FAILED,
  CREATE_FINANCIAL_YEARS_INIT,
  CREATE_FINANCIAL_YEARS_SUCCESS,
  CREATE_FINANCIAL_YEARS_FAILED,
  GET_VERSIONS_INIT,
  GET_VERSIONS_SUCCESS,
  GET_VERSIONS_FAILED,
  GET_DETAILED_VIEW_HEADERS_INIT,
  GET_DETAILED_VIEW_HEADERS_SUCCESS,
  GET_DETAILED_VIEW_HEADERS_FAILED,
  OPPORTUNITY_YEARS_LIST_INIT,
  OPPORTUNITY_YEARS_LIST_SUCCESS,
  SELECTED_OPP_YEAR_INIT,
  SELECTED_OPP_YEAR_SUCCESS,
} from "./types/financial-management-types";
import {
  getCapexRelatedExpenseBudgetDetailsAPI,
  getCapexRelatedExpenseForecastDetailsAPI,
  getDirectEmployeeBudgetDetailsAPI,
  getDirectEmployeeForecastDetailsAPI,
  getOtherDirectInHouseCostBudgetDetailsAPI,
  getOtherDirectInHouseCostForecastDetailsAPI,
  getVendorEmployeeBudgetDetailsAPI,
  getVendorEmployeeForecastDetailsAPI,
  getVendorRelatedCostBudgetDetailsAPI,
  getVendorRelatedCostForecastDetailsAPI,
  createUpdateCapexRelatedExpenseBudgetDetailsAPI,
  createUpdateCapexRelatedExpenseForecastDetailsAPI,
  createUpdateDirectEmployeeBudgetDetailsAPI,
  createUpdateDirectEmployeeForecastDetailsAPI,
  createUpdateOtherDirectInHouseBudgetDetailsAPI,
  createUpdateOtherDirectInHouseForecastDetailsAPI,
  createUpdateVendorEmploymentBudgetDetailsAPI,
  createUpdateVendorEmploymentForecastDetailsAPI,
  createUpdateVendorRelatedCostBudgetDetailsAPI,
  createUpdateVendorRelatedCostForecastDetailsAPI,
  getFinancialSummaryBudgetAPI,
  getFinancialSummaryForecastAPI,
  getUpcomingDeadlinesAPI,
  getBudgetVsForecastAPI,
  getTopProjectVariancesListAPI,
  getProjectVariancesCostWaterfallAPI,
  getContractSummaryAPI,
  getContractSummaryCostPlusAPI,
  getContractSummaryEACAPI,
  getDirectLaborDetailsAPI,
  getOtherDirectCostsDetailsAPI,
  getRevenueAPI,
  getMarginAPI,
  updateDirectLaborDetailsAPI,
  updateOtherDirectCostsDetailsAPI,
  updateMarginAPI,
  updateRevenueAPI,
  getDetailedViewRatesAPI,
  getDropdownOptionsAPI,
  updateDetailedViewRatesAPI,
  getListOfContractsAPI,
  downloadDetailedViewAPI,
  downloadPsrAPI,
  getFinancialYearSettingsAPI,
  getFinancialYearsAPI,
  createFinancialYearVersionAPI,
  getListOfVersionsAPI,
  getDetailedViewHeadersAPI,
} from "../api/financial-management-api";

export function getCapexRelatedExpenseBudgetDetails(year) {
  return (dispatch) => {
    dispatch({ type: GET_CAPEX_RELATED_BUDGET_INIT });
    getCapexRelatedExpenseBudgetDetailsAPI(year)
      .then((response) =>
        dispatch({ type: GET_CAPEX_RELATED_BUDGET_SUCCESS, response })
      )
      .catch((error) =>
        dispatch({ type: GET_CAPEX_RELATED_BUDGET_FAILED, error })
      );
  };
}

export function getCapexRelatedExpenseForecastDetails(year) {
  return (dispatch) => {
    dispatch({ type: GET_CAPEX_RELATED_FORECAST_INIT });
    getCapexRelatedExpenseForecastDetailsAPI(year)
      .then((response) =>
        dispatch({ type: GET_CAPEX_RELATED_FORECAST_SUCCESS, response })
      )
      .catch((error) =>
        dispatch({ type: GET_CAPEX_RELATED_FORECAST_FAILED, error })
      );
  };
}

export function getDirectEmployeeBudgetDetails(year) {
  return (dispatch) => {
    dispatch({ type: GET_DIRECT_EMPLOYEE_BUDGET_INIT });
    getDirectEmployeeBudgetDetailsAPI(year)
      .then((response) =>
        dispatch({ type: GET_DIRECT_EMPLOYEE_BUDGET_SUCCESS, response })
      )
      .catch((error) =>
        dispatch({ type: GET_DIRECT_EMPLOYEE_BUDGET_FAILED, error })
      );
  };
}

export function getDirectEmployeeForecastDetails(year) {
  return (dispatch) => {
    dispatch({ type: GET_DIRECT_EMPLOYEE_FORECAST_INIT });
    getDirectEmployeeForecastDetailsAPI(year)
      .then((response) =>
        dispatch({ type: GET_DIRECT_EMPLOYEE_FORECAST_SUCCESS, response })
      )
      .catch((error) =>
        dispatch({ type: GET_DIRECT_EMPLOYEE_FORECAST_FAILED, error })
      );
  };
}

export function getOtherDirectInHouseCostBudgetDetails(year) {
  return (dispatch) => {
    dispatch({ type: GET_OTHER_DIRECT_INHOUSE_COST_BUDGET_INIT });
    getOtherDirectInHouseCostBudgetDetailsAPI(year)
      .then((response) =>
        dispatch({
          type: GET_OTHER_DIRECT_INHOUSE_COST_BUDGET_SUCCESS,
          response,
        })
      )
      .catch((error) =>
        dispatch({ type: GET_OTHER_DIRECT_INHOUSE_COST_BUDGET_FAILED, error })
      );
  };
}

export function getOtherDirectInHouseCostForecastDetails(year) {
  return (dispatch) => {
    dispatch({ type: GET_OTHER_DIRECT_INHOUSE_COST_FORECAST_INIT });
    getOtherDirectInHouseCostForecastDetailsAPI(year)
      .then((response) =>
        dispatch({
          type: GET_OTHER_DIRECT_INHOUSE_COST_FORECAST_SUCCESS,
          response,
        })
      )
      .catch((error) =>
        dispatch({ type: GET_OTHER_DIRECT_INHOUSE_COST_FORECAST_FAILED, error })
      );
  };
}

export function getVendorEmployeeBudgetDetails(year) {
  return (dispatch) => {
    dispatch({ type: GET_VENDOR_EMPLOYEE_BUDGET_INIT });
    getVendorEmployeeBudgetDetailsAPI(year)
      .then((response) =>
        dispatch({
          type: GET_VENDOR_EMPLOYEE_BUDGET_SUCCESS,
          response,
        })
      )
      .catch((error) =>
        dispatch({ type: GET_VENDOR_EMPLOYEE_BUDGET_FAILED, error })
      );
  };
}

export function getVendorEmployeeForecastDetails(year) {
  return (dispatch) => {
    dispatch({ type: GET_VENDOR_EMPLOYEE_FORECAST_INIT });
    getVendorEmployeeForecastDetailsAPI(year)
      .then((response) =>
        dispatch({
          type: GET_VENDOR_EMPLOYEE_FORECAST_SUCCESS,
          response,
        })
      )
      .catch((error) =>
        dispatch({ type: GET_VENDOR_EMPLOYEE_FORECAST_FAILED, error })
      );
  };
}

export function getVendorRelatedCostBudgetDetails(year) {
  return (dispatch) => {
    dispatch({ type: GET_VENDOR_RELATED_COST_BUDGET_INIT });
    getVendorRelatedCostBudgetDetailsAPI(year)
      .then((response) =>
        dispatch({
          type: GET_VENDOR_RELATED_COST_BUDGET_SUCCESS,
          response,
        })
      )
      .catch((error) =>
        dispatch({ type: GET_VENDOR_RELATED_COST_BUDGET_FAILED, error })
      );
  };
}

export function getVendorRelatedCostForecastDetails(year) {
  return (dispatch) => {
    dispatch({ type: GET_VENDOR_RELATED_COST_FORECAST_INIT });
    getVendorRelatedCostForecastDetailsAPI(year)
      .then((response) =>
        dispatch({
          type: GET_VENDOR_RELATED_COST_FORECAST_SUCCESS,
          response,
        })
      )
      .catch((error) =>
        dispatch({ type: GET_VENDOR_RELATED_COST_FORECAST_FAILED, error })
      );
  };
}

export function createUpdateCapexRelatedExpenseBudgetDetails(body) {
  return (dispatch) => {
    dispatch({ type: UPDATE_CAPEX_RELATED_BUDGET_INIT });
    createUpdateCapexRelatedExpenseBudgetDetailsAPI(body)
      .then((response) =>
        dispatch({
          type: UPDATE_CAPEX_RELATED_BUDGET_SUCCESS,
          response,
        })
      )
      .catch((error) =>
        dispatch({ type: UPDATE_CAPEX_RELATED_BUDGET_FAILED, error })
      );
  };
}

export function createUpdateCapexRelatedExpenseForecastDetails(body) {
  return (dispatch) => {
    dispatch({ type: UPDATE_CAPEX_RELATED_FORECAST_INIT });
    createUpdateCapexRelatedExpenseForecastDetailsAPI(body)
      .then((response) =>
        dispatch({
          type: UPDATE_CAPEX_RELATED_FORECAST_SUCCESS,
          response,
        })
      )
      .catch((error) =>
        dispatch({ type: UPDATE_CAPEX_RELATED_FORECAST_FAILED, error })
      );
  };
}

export function createUpdateDirectEmployeeBudgetDetails(body) {
  return (dispatch) => {
    dispatch({ type: UPDATE_DIRECT_EMPLOYEE_BUDGET_INIT });
    createUpdateDirectEmployeeBudgetDetailsAPI(body)
      .then((response) =>
        dispatch({
          type: UPDATE_DIRECT_EMPLOYEE_BUDGET_SUCCESS,
          response,
        })
      )
      .catch((error) =>
        dispatch({ type: UPDATE_DIRECT_EMPLOYEE_BUDGET_FAILED, error })
      );
  };
}

export function createUpdateDirectEmployeeForecastDetails(body) {
  return (dispatch) => {
    dispatch({ type: UPDATE_DIRECT_EMPLOYEE_FORECAST_INIT });
    createUpdateDirectEmployeeForecastDetailsAPI(body)
      .then((response) =>
        dispatch({
          type: UPDATE_DIRECT_EMPLOYEE_FORECAST_SUCCESS,
          response,
        })
      )
      .catch((error) =>
        dispatch({ type: UPDATE_DIRECT_EMPLOYEE_FORECAST_FAILED, error })
      );
  };
}

export function createUpdateOtherDirectInHouseBudgetDetails(body) {
  return (dispatch) => {
    dispatch({ type: UPDATE_OTHER_DIRECT_INHOUSE_COST_BUDGET_INIT });
    createUpdateOtherDirectInHouseBudgetDetailsAPI(body)
      .then((response) =>
        dispatch({
          type: UPDATE_OTHER_DIRECT_INHOUSE_COST_BUDGET_SUCCESS,
          response,
        })
      )
      .catch((error) =>
        dispatch({
          type: UPDATE_OTHER_DIRECT_INHOUSE_COST_BUDGET_FAILED,
          error,
        })
      );
  };
}

export function createUpdateOtherDirectInHouseForecastDetails(body) {
  return (dispatch) => {
    dispatch({ type: UPDATE_OTHER_DIRECT_INHOUSE_COST_FORECAST_INIT });
    createUpdateOtherDirectInHouseForecastDetailsAPI(body)
      .then((response) =>
        dispatch({
          type: UPDATE_OTHER_DIRECT_INHOUSE_COST_FORECAST_SUCCESS,
          response,
        })
      )
      .catch((error) =>
        dispatch({
          type: UPDATE_OTHER_DIRECT_INHOUSE_COST_FORECAST_FAILED,
          error,
        })
      );
  };
}

export function createUpdateVendorEmploymentBudgetDetails(body) {
  return (dispatch) => {
    dispatch({ type: UPDATE_VENDOR_EMPLOYEE_BUDGET_INIT });
    createUpdateVendorEmploymentBudgetDetailsAPI(body)
      .then((response) =>
        dispatch({
          type: UPDATE_VENDOR_EMPLOYEE_BUDGET_SUCCESS,
          response,
        })
      )
      .catch((error) =>
        dispatch({
          type: UPDATE_VENDOR_EMPLOYEE_BUDGET_FAILED,
          error,
        })
      );
  };
}

export function createUpdateVendorEmploymentForecastDetails(body) {
  return (dispatch) => {
    dispatch({ type: UPDATE_VENDOR_EMPLOYEE_FORECAST_INIT });
    createUpdateVendorEmploymentForecastDetailsAPI(body)
      .then((response) =>
        dispatch({
          type: UPDATE_VENDOR_EMPLOYEE_FORECAST_SUCCESS,
          response,
        })
      )
      .catch((error) =>
        dispatch({
          type: UPDATE_VENDOR_EMPLOYEE_FORECAST_FAILED,
          error,
        })
      );
  };
}

export function createUpdateVendorRelatedCostBudgetDetails(body) {
  return (dispatch) => {
    dispatch({ type: UPDATE_VENDOR_RELATED_COST_BUDGET_INIT });
    createUpdateVendorRelatedCostBudgetDetailsAPI(body)
      .then((response) =>
        dispatch({
          type: UPDATE_VENDOR_RELATED_COST_BUDGET_SUCCESS,
          response,
        })
      )
      .catch((error) =>
        dispatch({
          type: UPDATE_VENDOR_RELATED_COST_BUDGET_FAILED,
          error,
        })
      );
  };
}

export function createUpdateVendorRelatedCostForecastDetails(body) {
  return (dispatch) => {
    dispatch({ type: UPDATE_VENDOR_RELATED_COST_FORECAST_INIT });
    createUpdateVendorRelatedCostForecastDetailsAPI(body)
      .then((response) =>
        dispatch({
          type: UPDATE_VENDOR_RELATED_COST_FORECAST_SUCCESS,
          response,
        })
      )
      .catch((error) =>
        dispatch({
          type: UPDATE_VENDOR_RELATED_COST_FORECAST_FAILED,
          error,
        })
      );
  };
}

export function getFinancialSummaryBudget(year) {
  return (dispatch) => {
    dispatch({ type: GET_FINANCIAL_SUMMARY_BUDGET_INIT });
    getFinancialSummaryBudgetAPI(year)
      .then((response) =>
        dispatch({
          type: GET_FINANCIAL_SUMMARY_BUDGET_SUCCESS,
          response,
        })
      )
      .catch((error) =>
        dispatch({
          type: GET_FINANCIAL_SUMMARY_BUDGET_FAILED,
          error,
        })
      );
  };
}

export function getFinancialSummaryForecast(year) {
  return (dispatch) => {
    dispatch({ type: GET_FINANCIAL_SUMMARY_FORECAST_INIT });
    getFinancialSummaryForecastAPI(year)
      .then((response) =>
        dispatch({
          type: GET_FINANCIAL_SUMMARY_FORECAST_SUCCESS,
          response,
        })
      )
      .catch((error) =>
        dispatch({
          type: GET_FINANCIAL_SUMMARY_FORECAST_FAILED,
          error,
        })
      );
  };
}

export function getBudgetVsForecast(year) {
  return (dispatch) => {
    dispatch({ type: GET_BUDGET_VS_FORECAST_INIT });
    getBudgetVsForecastAPI(year)
      .then((response) =>
        dispatch({
          type: GET_BUDGET_VS_FORECAST_SUCCESS,
          response,
        })
      )
      .catch((error) =>
        dispatch({
          type: GET_BUDGET_VS_FORECAST_FAILED,
          error,
        })
      );
  };
}

export function getProjectVariancesCostWaterfall(year) {
  return (dispatch) => {
    dispatch({ type: GET_PROJECT_VARIANCES_COST_WATERFALL_INIT });
    getProjectVariancesCostWaterfallAPI(year)
      .then((response) =>
        dispatch({
          type: GET_PROJECT_VARIANCES_COST_WATERFALL_SUCCESS,
          response,
        })
      )
      .catch((error) =>
        dispatch({
          type: GET_PROJECT_VARIANCES_COST_WATERFALL_FAILED,
          error,
        })
      );
  };
}

export function getTopProjectVariancesList(year) {
  return (dispatch) => {
    dispatch({ type: GET_TOP_PROJECT_VARIANCE_LIST_INIT });
    getTopProjectVariancesListAPI(year)
      .then((response) =>
        dispatch({
          type: GET_TOP_PROJECT_VARIANCE_LIST_SUCCESS,
          response,
        })
      )
      .catch((error) =>
        dispatch({
          type: GET_TOP_PROJECT_VARIANCE_LIST_FAILED,
          error,
        })
      );
  };
}

export function getUpcomingDeadlines() {
  return (dispatch) => {
    dispatch({ type: GET_UPCOMING_DEADLINES_INIT });
    getUpcomingDeadlinesAPI()
      .then((response) =>
        dispatch({
          type: GET_UPCOMING_DEADLINES_SUCCESS,
          response,
        })
      )
      .catch((error) =>
        dispatch({
          type: GET_UPCOMING_DEADLINES_FAILED,
          error,
        })
      );
  };
}

export function getContractSummary(contractId, version, financialYear) {
  return (dispatch) => {
    dispatch({ type: GET_CONTRACT_SUMMARY_INIT });
    getContractSummaryAPI(contractId, version, financialYear)
      .then((response) =>
        dispatch({
          type: GET_CONTRACT_SUMMARY_SUCCESS,
          response,
        })
      )
      .catch((error) =>
        dispatch({
          type: GET_CONTRACT_SUMMARY_FAILED,
          error,
        })
      );
  };
}

export function getContractSummaryEAC(contractId, year) {
  return (dispatch) => {
    dispatch({ type: GET_CONTRACT_SUMMARY_EAC_INIT });
    getContractSummaryEACAPI(contractId, year)
      .then((response) =>
        dispatch({
          type: GET_CONTRACT_SUMMARY_EAC_SUCCESS,
          response,
        })
      )
      .catch((error) =>
        dispatch({
          type: GET_CONTRACT_SUMMARY_EAC_FAILED,
          error,
        })
      );
  };
}

export function getContractSummaryCostPlus(contractId, version, financialYear) {
  return (dispatch) => {
    dispatch({ type: GET_CONTRACT_SUMMARY_COST_PLUS_INIT });
    getContractSummaryCostPlusAPI(contractId, version, financialYear)
      .then((response) =>
        dispatch({
          type: GET_CONTRACT_SUMMARY_COST_PLUS_SUCCESS,
          response,
        })
      )
      .catch((error) =>
        dispatch({
          type: GET_CONTRACT_SUMMARY_COST_PLUS_FAILED,
          error,
        })
      );
  };
}

export function getDirectLaborDetails(
  contractId,
  templateType,
  contractYear,
  version,
  financialYear
) {
  return (dispatch) => {
    dispatch({ type: GET_DIRECT_LABOR_DETAILS_INIT });
    getDirectLaborDetailsAPI(
      contractId,
      templateType,
      contractYear,
      version,
      financialYear
    )
      .then((response) =>
        dispatch({
          type: GET_DIRECT_LABOR_DETAILS_SUCCESS,
          response,
        })
      )
      .catch((error) =>
        dispatch({
          type: GET_DIRECT_LABOR_DETAILS_FAILED,
          error,
        })
      );
  };
}

export function updateDirectLaborDetails(
  contractId,
  templateType,
  version,
  body,
  financialYear
) {
  return (dispatch) => {
    dispatch({ type: UPDATE_DIRECT_LABOR_DETAILS_INIT });
    updateDirectLaborDetailsAPI(
      contractId,
      templateType,
      version,
      body,
      financialYear
    )
      .then((response) =>
        dispatch({
          type: UPDATE_DIRECT_LABOR_DETAILS_SUCCESS,
          response,
        })
      )
      .catch((error) =>
        dispatch({
          type: UPDATE_DIRECT_LABOR_DETAILS_FAILED,
          error,
        })
      );
  };
}

export function getOtherDirectCostsDetails(
  contractId,
  templateType,
  contractYear,
  version,
  financialYear
) {
  return (dispatch) => {
    dispatch({ type: GET_OTHER_DIRECT_COSTS_INIT });
    getOtherDirectCostsDetailsAPI(
      contractId,
      templateType,
      contractYear,
      version,
      financialYear
    )
      .then((response) =>
        dispatch({
          type: GET_OTHER_DIRECT_COSTS_SUCCESS,
          response,
        })
      )
      .catch((error) =>
        dispatch({
          type: GET_OTHER_DIRECT_COSTS_FAILED,
          error,
        })
      );
  };
}

export function updateOtherDirectCostsDetails(
  contractId,
  templateType,
  contractYear,
  version,
  body,
  financialYear
) {
  return (dispatch) => {
    dispatch({ type: UPDATE_OTHER_DIRECT_COSTS_INIT });
    updateOtherDirectCostsDetailsAPI(
      contractId,
      templateType,
      contractYear,
      version,
      body,
      financialYear
    )
      .then((response) =>
        dispatch({
          type: UPDATE_OTHER_DIRECT_COSTS_SUCCESS,
          response,
        })
      )
      .catch((error) =>
        dispatch({
          type: UPDATE_OTHER_DIRECT_COSTS_FAILED,
          error,
        })
      );
  };
}

export function getRevenue(
  contractId,
  templateType,
  contractYear,
  version,
  financialYear
) {
  return (dispatch) => {
    dispatch({ type: GET_REVENUE_INIT });
    getRevenueAPI(
      contractId,
      templateType,
      contractYear,
      version,
      financialYear
    )
      .then((response) =>
        dispatch({
          type: GET_REVENUE_SUCCESS,
          response,
        })
      )
      .catch((error) =>
        dispatch({
          type: GET_REVENUE_FAILED,
          error,
        })
      );
  };
}

export function updateRevenue(
  contractId,
  templateType,
  version,
  body,
  financialYear
) {
  return (dispatch) => {
    dispatch({ type: UPDATE_REVENUE_INIT });
    updateRevenueAPI(contractId, templateType, version, body, financialYear)
      .then((response) =>
        dispatch({
          type: UPDATE_REVENUE_SUCCESS,
          response,
        })
      )
      .catch((error) =>
        dispatch({
          type: UPDATE_REVENUE_FAILED,
          error,
        })
      );
  };
}

export function getMargin(
  contractId,
  templateType,
  contractYear,
  version,
  financialYear
) {
  return (dispatch) => {
    dispatch({ type: GET_MARGIN_INIT });
    getMarginAPI(contractId, templateType, contractYear, version, financialYear)
      .then((response) =>
        dispatch({
          type: GET_MARGIN_SUCCESS,
          response,
        })
      )
      .catch((error) =>
        dispatch({
          type: GET_MARGIN_FAILED,
          error,
        })
      );
  };
}

export function updateMargin(
  contractId,
  templateType,
  version,
  body,
  financialYear
) {
  return (dispatch) => {
    dispatch({ type: UPDATE_MARGIN_INIT });
    updateMarginAPI(contractId, templateType, version, body, financialYear)
      .then((response) =>
        dispatch({
          type: UPDATE_MARGIN_SUCCESS,
          response,
        })
      )
      .catch((error) =>
        dispatch({
          type: UPDATE_MARGIN_FAILED,
          error,
        })
      );
  };
}

export function clearCostplusData() {
  return (dispatch) => {
    dispatch({ type: GET_MARGIN_INIT });
    dispatch({ type: GET_REVENUE_INIT });
    dispatch({ type: GET_OTHER_DIRECT_COSTS_INIT });
    dispatch({ type: GET_DIRECT_LABOR_DETAILS_INIT });
    dispatch({ type: GET_CONTRACT_YEARS_INIT });
    dispatch({ type: GET_VERSIONS_INIT });
    dispatch({ type: GET_DETAILED_VIEW_HEADERS_INIT });
    dispatch({ type: GET_DETAILED_VIEW_RATES_INIT });
  };
}

export function getDetailedViewRates(
  contractId,
  contractYear,
  financialYear,
  version
) {
  return (dispatch) => {
    dispatch({ type: GET_DETAILED_VIEW_RATES_INIT });
    getDetailedViewRatesAPI(contractId, contractYear, financialYear, version)
      .then((response) =>
        dispatch({
          type: GET_DETAILED_VIEW_RATES_SUCCESS,
          response,
        })
      )
      .catch((error) =>
        dispatch({
          type: GET_DETAILED_VIEW_RATES_FAILED,
          error,
        })
      );
  };
}

export function getDropdownOptions(contractId, version, financialYear) {
  return (dispatch) => {
    dispatch({ type: GET_CONTRACT_YEARS_INIT });
    getDropdownOptionsAPI(contractId, version, financialYear)
      .then((response) =>
        dispatch({
          type: GET_CONTRACT_YEARS_SUCCESS,
          response,
        })
      )
      .catch((error) =>
        dispatch({
          type: GET_CONTRACT_YEARS_FAILED,
          error,
        })
      );
  };
}

export function updateDetailedViewRates(
  contractId,
  templateType,
  body,
  financialYear,
  version
) {
  return (dispatch) => {
    dispatch({ type: UPDATE_DETAILED_VIEW_RATES_INIT });
    updateDetailedViewRatesAPI(
      contractId,
      templateType,
      body,
      financialYear,
      version
    )
      .then((response) =>
        dispatch({
          type: UPDATE_DETAILED_VIEW_RATES_SUCCESS,
          response,
        })
      )
      .catch((error) =>
        dispatch({
          type: UPDATE_DETAILED_VIEW_RATES_FAILED,
          error,
        })
      );
  };
}

export function getListOfContracts() {
  return (dispatch) => {
    dispatch({ type: GET_CONTRACTS_INIT });
    getListOfContractsAPI()
      .then((response) =>
        dispatch({
          type: GET_CONTRACTS_SUCCESS,
          response,
        })
      )
      .catch((error) =>
        dispatch({
          type: GET_CONTRACTS_FAILED,
          error,
        })
      );
  };
}

export function downloadDetailedView(
  contractId,
  templateType,
  contractYear,
  version,
  financialYear
) {
  return (dispatch) => {
    dispatch({ type: DOWNLOAD_DETAILED_VIEW_INIT });
    downloadDetailedViewAPI(
      contractId,
      templateType,
      contractYear,
      version,
      financialYear
    )
      .then((response) =>
        dispatch({
          type: DOWNLOAD_DETAILED_VIEW_SUCCESS,
          response,
        })
      )
      .catch((error) =>
        dispatch({
          type: DOWNLOAD_DETAILED_VIEW_FAILED,
          error,
        })
      );
  };
}
export function downloadPsr(contractId, version, clins) {
  return (dispatch) => {
    dispatch({ type: DOWNLOAD_PSR_INIT });
    downloadPsrAPI(contractId, version, clins)
      .then((response) =>
        dispatch({
          type: DOWNLOAD_PSR_SUCCESS,
          response,
        })
      )
      .catch((error) =>
        dispatch({
          type: DOWNLOAD_PSR_FAILED,
          error,
        })
      );
  };
}

export function getFinancialYearSettings() {
  return (dispatch) => {
    dispatch({ type: GET_FINANCIAL_YEAR_SETTINGS_INIT });
    getFinancialYearSettingsAPI()
      .then((response) =>
        dispatch({
          type: GET_FINANCIAL_YEAR_SETTINGS_SUCCESS,
          response,
        })
      )
      .catch((error) =>
        dispatch({
          type: GET_FINANCIAL_YEAR_SETTINGS_FAILED,
          error,
        })
      );
  };
}

export function getFinancialYears(id) {
  return (dispatch) => {
    dispatch({ type: GET_FINANCIAL_YEARS_INIT });
    getFinancialYearsAPI(id)
      .then((response) =>
        dispatch({
          type: GET_FINANCIAL_YEARS_SUCCESS,
          response,
        })
      )
      .catch((error) =>
        dispatch({
          type: GET_FINANCIAL_YEARS_FAILED,
          error,
        })
      );
  };
}

export function createFinancialYearVersion(body) {
  return (dispatch) => {
    dispatch({ type: CREATE_FINANCIAL_YEARS_INIT });
    createFinancialYearVersionAPI(body)
      .then((response) =>
        dispatch({
          type: CREATE_FINANCIAL_YEARS_SUCCESS,
          response,
        })
      )
      .catch((error) =>
        dispatch({
          type: CREATE_FINANCIAL_YEARS_FAILED,
          error,
        })
      );
  };
}

export function getListOfVersions(id) {
  return (dispatch) => {
    dispatch({ type: GET_VERSIONS_INIT });
    getListOfVersionsAPI(id)
      .then((response) =>
        dispatch({
          type: GET_VERSIONS_SUCCESS,
          response,
        })
      )
      .catch((error) =>
        dispatch({
          type: GET_VERSIONS_FAILED,
          error,
        })
      );
  };
}

export function getDetailedViewHeaders(
  contractId,
  templateType,
  version,
  financialYear
) {
  return (dispatch) => {
    dispatch({ type: GET_DETAILED_VIEW_HEADERS_INIT });
    getDetailedViewHeadersAPI(contractId, templateType, version, financialYear)
      .then((response) =>
        dispatch({
          type: GET_DETAILED_VIEW_HEADERS_SUCCESS,
          response,
        })
      )
      .catch((error) =>
        dispatch({
          type: GET_DETAILED_VIEW_HEADERS_FAILED,
          error,
        })
      );
  };
}

export function setOppYearsList(years) {
  return (dispatch) => {
    dispatch({ type: OPPORTUNITY_YEARS_LIST_INIT });
    dispatch({
      type: OPPORTUNITY_YEARS_LIST_SUCCESS,
      years,
    });
  };
}

export function setSelectedOppYear(year) {
  return (dispatch) => {
    dispatch({ type: SELECTED_OPP_YEAR_INIT });
    dispatch({
      type: SELECTED_OPP_YEAR_SUCCESS,
      year,
    });
  };
}
